import {
  BaseError,
  createErrorBuilder,
} from "@wix/public-editor-platform-errors";

export enum DataBindingKeyManagerErrorCode {
  InvalidBindingKeyFormat = "InvalidBindingKeyFormat",
  UnsupportedBindingType = "UnsupportedBindingType",
}

class DataBindingKeyManagerError extends BaseError<DataBindingKeyManagerErrorCode> {
  constructor(message: string, code: DataBindingKeyManagerErrorCode) {
    super(message, code, "Data Binding Key Manager Error");
  }
}

export const createDataBindingKeyManagerError = createErrorBuilder<
  DataBindingKeyManagerErrorCode,
  DataBindingKeyManagerError
>(DataBindingKeyManagerError);
